import * as Yup from 'yup';

/** @constant {ObjectShape} - Yup Object used for validation schema in feedback form */
const AIFeedbackSchema = Yup.object().shape({
  aisystemId: Yup.string().required('AI Solution is required'),

  name: Yup.string()
    .required('Name is required')
    .max(80, 'Name can have a maximum of 80 characters'),

  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required')
    .max(120, 'Email can have a maximum of 120 characters'),
  category: Yup.string().required('AI Solution is required'),

  feedbackType: Yup.string().required('Feedback type is required'),

  feedback: Yup.string()
    .required('Feedback is required')
    .max(1000, 'Feedback can have a maximum of 1000 characters'),
});

export { AIFeedbackSchema };
